import { useMemo } from 'react';
import { AppAuthProvider } from './AppAuthContext.js';
import useAuthState from './useAuthState.js';

const AppAuthProviderWrapper = ({ children }) => {
  const authState = useAuthState();

  const contextValue = useMemo(
    () => ({
      userId: authState.userId,
      selectedAccount: authState.selectedAccount,
      getGlobalInformation: authState.getGlobalInformation,
      clear: authState.clear,
    }),
    [authState.userId, authState.selectedAccount, authState.getGlobalInformation, authState.clear],
  );

  return <AppAuthProvider value={contextValue}>{children}</AppAuthProvider>;
};

export default AppAuthProviderWrapper;
